<template>
  <div>
    <!-- No test run is available -->
    <q-icon v-if="!testResult || testResult.isDirty" name="brightness_1" size="sm" color="grey-5">
      <q-tooltip>The test case has not been run after the latest changes.</q-tooltip>
    </q-icon>

    <!-- An error received -->
    <div v-else-if="testResult && testResult.error">
      <q-icon name="error" size="sm" color="red-5">
        <q-tooltip>
          Received error:
          <pre class="detailed-result" v-html="resultAsHtml" />
          <pre class="pre-wrap">{{ testResult.error.traceback }}</pre>
        </q-tooltip>
      </q-icon>
    </div>

    <!-- A result was received -->
    <div v-else>
      <!-- Test Failed -->
      <q-icon v-if="!testResult.test_passed" name="highlight_off" size="sm" color="red-5" data-id="failIcon">
        <q-tooltip>
          Test Failed. Received result:
          <pre class="detailed-result" v-html="resultAsHtml" />
          <div class="pre-wrap">{{ failureMessage }}</div>
        </q-tooltip>
      </q-icon>

      <!-- Test Pass -->
      <q-icon v-if="testResult.test_passed" name="check_circle_outline" size="sm" color="green-5" data-id="successIcon">
        <q-tooltip>
          Test Passed. Received result:
          <br />
          <pre class="detailed-result" v-html="resultAsHtml" />
        </q-tooltip>
      </q-icon>
    </div>
  </div>
</template>

<script lang="ts">
import * as testExpectationUtils from '@/utils/testExpectationUtils'
import type { TestResult } from '@klarna/cbrms-policy-rules-manager-client-ts'
import { computed, defineComponent } from 'vue'

interface Props {
  testResult: TestResult
}

export default defineComponent<Props>({
  props: {
    testResult: {
      type: Object,
      default: () => undefined,
    },
  },
  setup(props) {
    return {
      resultAsHtml: computed(() => testExpectationUtils.getTestResultAsString(props.testResult)),
      failureMessage: computed<string | undefined>(() => {
        if (!props.testResult.unmatched_expectations || !props.testResult.unmatched_expectations.length) return ''

        const message = props.testResult.unmatched_expectations[0]
        return message.substring(message.indexOf(':') + 2)
      }),
    }
  },
})
</script>

<style lang="scss" scoped>
@import '@/styles/quasar.variables.scss';

.detailed-result {
  margin: $space-y-xs 0;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.5;
  white-space: pre-wrap;
}

.pre-wrap {
  white-space: pre-wrap;
}
</style>
